<app-page-loader-v01-h00-c00></app-page-loader-v01-h00-c00>
<div *ngIf="currentNavigation == 'login'" class="wrapper login">
  <!-- <app-header-v01-h00-c00></app-header-v01-h00-c00> -->
  <app-header-v01-h00-c00-dev></app-header-v01-h00-c00-dev>
  <router-outlet></router-outlet>
  <app-footer-v01-h00-c00></app-footer-v01-h00-c00>
</div>

<div *ngIf=" currentNavigation != '' && currentNavigation != 'login' && currentNavigation != '/ssoauth/appredirect'" class="wrapper">
  <!-- <app-header-v01-h00-c00></app-header-v01-h00-c00> -->
  <app-header-v01-h00-c00-dev></app-header-v01-h00-c00-dev>
  <div class="contentArea">
    <router-outlet></router-outlet>
  </div>
  <!-- BOTTOM NAV STARTS HERE -->
  <app-bottom-navigation-v01-h00-c00></app-bottom-navigation-v01-h00-c00>
  <!-- BOTTOM NAV ENDS HERE -->
  <app-footer-v01-h00-c00></app-footer-v01-h00-c00>
</div>

<div *ngIf=" currentNavigation != '' && currentNavigation == '/ssoauth/appredirect'" class="wrapper">
  <!-- <app-header-v01-h00-c00></app-header-v01-h00-c00> -->
  <!-- <app-header-v01-h00-c00-dev></app-header-v01-h00-c00-dev> -->
  <div class="contentArea">
    <!-- <router-outlet *ngIf="renderMainContent"></router-outlet> -->
     <router-outlet></router-outlet>
  </div>
  <!-- BOTTOM NAV STARTS HERE -->
  <app-bottom-navigation-v01-h00-c00></app-bottom-navigation-v01-h00-c00>
  <!-- BOTTOM NAV ENDS HERE -->
  <app-footer-v01-h00-c00></app-footer-v01-h00-c00>
</div>

<app-modal-popup-v01-h00-c00-privacy-policy></app-modal-popup-v01-h00-c00-privacy-policy>
<app-modal-popup-v01-h00-c00-browser-compatibility></app-modal-popup-v01-h00-c00-browser-compatibility>
<app-modal-popup-v01-h00-c00-security-policy></app-modal-popup-v01-h00-c00-security-policy>
<app-modal-popup-v01-h00-c00-version></app-modal-popup-v01-h00-c00-version>
<app-modal-v01-h02-c00-logout></app-modal-v01-h02-c00-logout>
